import { lazy } from 'react';
import { screenOptionsForDarkMode } from '../../../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../../../functions/navigation/utils/wrapNavigatorScreen';

const DiscoveryFeaturedEventListPageContent = lazy(
  () => import('./list-page-content'),
);

export const DiscoveryFeaturedEventListPage = wrapLazyNavigatorScreen(
  DiscoveryFeaturedEventListPageContent,
  screenOptionsForDarkMode({ title: 'Featured' }),
);
